<template>
  <div class="new_vip">
    <div class="title_line" v-if="!isCheck">
      <el-page-header @back="goBack" content="交班"></el-page-header>
    </div>
    <div class="button_box" v-if="!isCheck">
      <el-button
        type="primary"
        style="margin: 20px 10px;"
        @click="submit()"
        v-if="ifPrint"
        v-print="'#print_table'"
      >
        确定交班
      </el-button>
      <el-button
        type="primary"
        style="margin: 20px 10px;"
        @click="submit()"
        v-else
      >
        确定交班
      </el-button>
      <el-checkbox v-model="ifPrint" label="打印" border></el-checkbox>
      <el-button
        style="margin: 20px 10px;"
        @click="gotoHome()"
        v-if="showBackButton"
      >
        返回首页
      </el-button>
      <el-button
        v-if="Duty_type.duty_type == 0"
        style="margin-left: 20px;"
        @click="gotoNew2()"
      >
        切换到新版交班
      </el-button>
    </div>

    <div class="content" v-if="show_print">
      <div class="print_table" id="print_table" ref="print">
        <div class="print_table_line noborder">
          <span>班次时间：{{ nowDate }}</span>
          <span v-if="room_name">({{ room_name }})</span>
        </div>
        <div class="print_table_line" v-if="false">
          <div class="flex2">会员增长</div>
          <div class="flex2">{{ detailData.inc_num }}</div>
          <div class="flex3">优惠券发送张数</div>
          <div class="flex2">{{ detailData.send_num }}</div>
          <div class="flex3">优惠券使用总数</div>
          <div class="flex2">{{ detailData.use_num }}</div>
        </div>
        <div class="print_table_line" v-if="false">
          <span>积分</span>
        </div>
        <div class="print_table_line" v-if="false">
          <div class="flex3">产生积分总数</div>
          <div class="flex2">{{ detailData.up_points }}</div>
          <div class="flex3">积分抵扣金额</div>
          <div class="flex2">{{ detailData.dec_point_money }}</div>
          <div class="flex2">礼品兑换</div>
          <div class="flex2">{{ detailData.credit_points }}</div>
        </div>
        <div class="print_table_line">
          <span>充值</span>
        </div>
        <div class="print_table_line">
          <div class="flex1">充值单数</div>
          <div class="flex1">
            {{
              detailData.recharge_ids == ""
                ? "0"
                : detailData.recharge_ids.split(",").length
            }}
          </div>
          <div class="flex1">充值总金额</div>
          <div class="flex1">{{ detailData.ex_goods_amount }}</div>
          <div class="flex1">赠送金额</div>
          <div class="flex1">{{ detailData.ex_goods_balance }}</div>
        </div>
        <div class="print_table_line">
          <div class="flex1_ex">支付方式</div>
          <div class="flex1_ex_li">
            <div class="noborder">现金：{{ detailData.ex_cash_amount }}</div>
            <div class="noborder">
              银联：{{ detailData.show_recharge_unionpay_amount }}
            </div>
            <div class="noborder">手续费：{{ detailData.recharge_fee }}</div>
            <div class="noborder">
              实际入账：{{
                (
                  Number(detailData.show_recharge_unionpay_amount) -
                  Number(detailData.recharge_fee)
                ).toFixed(2)
              }}
            </div>
          </div>
        </div>
        <div class="print_table_line" v-if="duty_charge_count == 1">
          <div class="flex1_ex bd_none">充值统计</div>
          <div class="flex1 half_lh">
            <div class="half_item">总充值：{{ settle.recharge || 0 }}元</div>
            <div class="half_item">
              总充值赠送：{{ settle.recharge_balance || 0 }}元
            </div>
            <!-- <div class="half_item">总账户剩余：{{settle.balance}}元</div> -->
            <div class="half_item">
              后台总增加：{{ settle.admin_inc || 0 }}元
            </div>
            <div class="half_item">
              后台总减少：{{ settle.admin_dec || 0 }}元
            </div>
            <div class="half_item">订单总消费：{{ settle.order || 0 }}元</div>
          </div>
        </div>
        <div class="print_table_line" v-if="duty_charge_count == 1">
          <div class="flex1_ex bd_none">总账户剩余</div>
          <div class="flex1 half_lh">
            <div class="half_item" style="width: 120px; font-size: 16px;">
              {{ settle.balance || 0 }}元
            </div>
            <span class="info_text">
              计算方式: 总充值 + 总赠送 + 后台增加 - 总订单消费 - 后台减少
            </span>
          </div>
        </div>
        <div>
          <div class="print_table_line">
            <span>便利店订单</span>
          </div>
          <div class="print_table_line">
            <div class="column1" style="line-height: 80px;"></div>
            <div class="part_order">
              <div class="part_title">便利店订单</div>
              <div class="part_line">
                <div class="part_item bd_none">单数</div>
                <div class="part_item">应收</div>
                <!-- <div class="part_item">优惠</div> -->
                <div class="part_item">实收</div>
              </div>
            </div>
            <div class="part_stat">
              <div class="part_title">支付方式</div>
              <div class="part_line">
                <div class="part_item_payment bd_none" style="width: 50%;">
                  现金
                </div>
                <div
                  class="part_item_payment"
                  style="width: 50%; text-align: center;"
                >
                  线上支付
                </div>
              </div>
            </div>
          </div>
          <div class="print_table_line">
            <div class="column1">总计</div>
            <div class="part_order">
              <div class="part_line line_h50">
                <div class="part_item bd_none">
                  {{ creditshop_data.sum || 0 }}
                </div>
                <div class="part_item">
                  {{ creditshop_data.receivable_money || 0 }}
                </div>
                <!-- <div class="part_item">{{detailData.count.normal.normal_num}}</div> -->
                <div class="part_item">
                  {{ creditshop_data.receipts_money || 0 }}
                </div>
              </div>
            </div>
            <div class="part_stat">
              <div class="part_line line_h50">
                <div class="part_item_payment bd_none" style="width: 50%;">
                  {{ creditshop_data.cash_money || 0 }}
                </div>
                <div
                  class="part_item_payment"
                  style="width: 50%; text-align: center;"
                >
                  {{ creditshop_data.online_money || 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="detailData.platform_card_order_num > 0">
          <div class="print_table_line">
            <span>平台卡</span>
          </div>
          <div class="print_table_line">
            <div class="part_order" style="width: 100%;">
              <div class="part_line">
                <!--                <div class="column1" style="width: 78px;"></div>-->
                <div class="part_item">单数</div>
                <div class="part_item">应收</div>
                <div class="part_item">平台扣除</div>
                <div class="part_item">手续费</div>
                <div class="part_item">实收</div>
              </div>
            </div>
          </div>
          <div class="print_table_line" style="justify-content: unset;">
            <!--            <div  style="width: 78px;">总计</div>-->
            <div class="part_order" style="width: 100%;">
              <div class="part_line line_h50">
                <div class="part_item bd_none">
                  {{ detailData.platform_card_order_num || 0 }}
                </div>
                <div class="part_item">
                  {{ detailData.platform_card_order_money || 0 }}
                </div>
                <div class="part_item">
                  {{ detailData.platform_card_order_platform_money || 0 }}
                </div>
                <div class="part_item">
                  {{ detailData.platform_card_order_fee || 0 }}
                </div>
                <div class="part_item">
                  {{ detailData.platform_card_order_amount || 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="normal_order && normal_order.normal_num > 0">
          <div class="print_table_line">
            <span>普通订单</span>
          </div>
          <div class="print_table_line">
            <div class="column1" style="line-height: 80px;"></div>
            <div class="part_order">
              <div class="part_title">普通订单</div>
              <div class="part_line">
                <div class="part_item bd_none">单数</div>
                <div class="part_item">应收</div>
                <!-- <div class="part_item">优惠</div> -->
                <div class="part_item">实收</div>
              </div>
            </div>
            <div class="part_stat">
              <div class="part_title">支付方式</div>
              <div class="part_line">
                <div class="part_item_payment bd_none">现金</div>
                <div class="part_item_payment" style="width: 144px;">
                  线上支付
                </div>
                <div class="part_item_payment">其他</div>
                <div class="part_item_payment">POS</div>
                <div class="part_item_payment">手续费</div>
                <!-- <div class="part_item">总计</div> -->
              </div>
            </div>
          </div>
          <div class="print_table_line">
            <div class="column1">总计</div>
            <div class="part_order">
              <div class="part_line line_h50">
                <div class="part_item bd_none">
                  {{ normal_order.normal_num || 0 }}
                </div>
                <div class="part_item">
                  {{ normal_order.normal_money || 0 }}
                </div>
                <!-- <div class="part_item">{{detailData.count.normal.normal_num}}</div> -->
                <div class="part_item">
                  {{ normal_order.normal_amount || 0 }}
                </div>
              </div>
            </div>
            <div class="part_stat">
              <div class="part_line line_h50">
                <div class="part_item_payment bd_none">
                  {{ normal_order.normal_cash || 0 }}
                </div>
                <div class="part_item_payment" style="width: 144px;">
                  {{
                    Number(normal_order.normal_unionpay) +
                      Number(normal_order.normal_wxpay) || 0
                  }}
                </div>
                <div class="part_item_payment">
                  {{ normal_order.normal_other || 0 }}
                </div>
                <div class="part_item_payment">
                  {{ normal_order.normal_pos || 0 }}
                </div>
                <div class="part_item_payment">
                  {{ normal_order.normal_fee || 0 }}
                </div>
                <!-- <div class="part_item">{{detailData.count.normal.normal_num}}</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="print_table_line">
          <span>油品订单</span>
        </div>
        <div class="print_table_line">
          <div class="flex2"></div>
          <div class="flex2">升数</div>
          <div class="flex2">单数</div>
          <div class="flex2">应收</div>
          <div class="flex2">优惠</div>
          <div class="flex2">实收</div>
        </div>
        <div class="print_table_line">
          <div class="flex2">汽油</div>
          <div class="flex2">{{ detailData.gasoli_num }}</div>
          <div class="flex2">{{ detailData.gasoli_order_num }}</div>
          <div class="flex2">{{ detailData.gasoli_order_money }}</div>
          <div class="flex2">{{ detailData.gasoli_discount }}</div>
          <div class="flex2">{{ detailData.gasoli_amount }}</div>
        </div>
        <div class="print_table_line">
          <div class="flex2">柴油</div>
          <div class="flex2">{{ detailData.diesel_num }}</div>
          <div class="flex2">{{ detailData.diesel_order_num }}</div>
          <div class="flex2">{{ detailData.diesel_order_money }}</div>
          <div class="flex2">{{ detailData.diesel_discount }}</div>
          <div class="flex2">{{ detailData.diesel_amount }}</div>
        </div>
        <div class="print_table_line">
          <div class="flex2">天然气</div>
          <div class="flex2">{{ detailData.lng_num }}</div>
          <div class="flex2">{{ detailData.lng_order_num }}</div>
          <div class="flex2">{{ detailData.lng_order_money }}</div>
          <div class="flex2">{{ detailData.lng_discount || 0 }}</div>
          <div class="flex2">{{ detailData.lng_amount }}</div>
        </div>
        <div class="print_table_line">
          <div class="flex2">合计</div>
          <div class="flex2">
            {{
              (
                Number(detailData.gasoli_num) +
                Number(detailData.diesel_num) +
                Number(detailData.lng_num)
              ).toFixed(2)
            }}
          </div>
          <div class="flex2">
            {{
              (
                Number(detailData.gasoli_order_num) +
                Number(detailData.diesel_order_num) +
                Number(detailData.lng_order_num)
              ).toFixed(2)
            }}
          </div>
          <div class="flex2">
            {{
              (
                Number(detailData.gasoli_order_money) +
                Number(detailData.diesel_order_money) +
                Number(detailData.lng_order_money)
              ).toFixed(2)
            }}
          </div>
          <div class="flex2">
            {{
              (
                Number(detailData.gasoli_discount) +
                Number(detailData.diesel_discount) +
                Number(detailData.lng_discount || 0)
              ).toFixed(2)
            }}
          </div>
          <div class="flex2">
            {{
              (
                Number(detailData.gasoli_amount) +
                Number(detailData.diesel_amount) +
                Number(detailData.lng_amount)
              ).toFixed(2)
            }}
          </div>
        </div>
        <div class="print_table_line">
          <div class="flex1_ex" style="line-height: 96px;">支付方式</div>
          <div class="flex5">
            <div class="detail_line" style="margin-top: 10px;">
              <div class="small_line">
                银联支付：{{
                  detailData.show_order_unionpay_amount
                }}(包含pos终端:{{ detailData.pos_unionpay_amount }})
              </div>
              <div class="small_line">手续费：{{ detailData.order_fee }}</div>
              <div class="small_line">
                实际入账：{{
                  (
                    Number(detailData.show_order_unionpay_amount) -
                    Number(detailData.order_fee)
                  ).toFixed(2)
                }}
              </div>
            </div>
            <div class="detail_line">
              <div class="small_line">
                储值支付：{{ detailData.show_all_recharge }}
              </div>
              <div class="small_line">现金支付：{{ detailData.cash }}</div>
            </div>
          </div>
        </div>
        <div class="print_table_line" v-if="show_stat">
          <span>收入统计</span>
          <span class="info_text">
            收入统计为当前班次实际收入，包括充值和油品订单的银联与现金收入。(余额，加油卡，亲情卡，车队卡支付不计入)
          </span>
        </div>
        <div class="print_table_line" v-if="show_stat">
          <div class="flex3">银联收入</div>
          <div class="flex4">
            {{
              (
                Number(detailData.show_unionpay_total) +
                Number(creditshop_data.online_money || 0)
              ).toFixed(2)
            }}
          </div>
          <div class="flex3">现金收入</div>
          <div class="flex4">
            {{
              (
                Number(detailData.cash) +
                Number(detailData.ex_cash_amount) +
                Number(normal_order ? normal_order.normal_cash : 0) +
                Number(creditshop_data.cash_money || 0)
              ).toFixed(2)
            }}
          </div>
          <div class="flex3">手续费</div>
          <div class="flex4">
            {{
              (
                Number(detailData.recharge_fee) +
                Number(detailData.order_fee) +
                Number(normal_order ? normal_order.normal_fee : 0)
              ).toFixed(2)
            }}
          </div>
          <div class="flex3">实际总收入</div>
          <div class="flex4">
            {{
              (
                Number(detailData.show_unionpay_total) +
                Number(normal_order ? normal_order.normal_cash : 0) +
                Number(detailData.cash) +
                Number(detailData.ex_cash_amount) -
                Number(detailData.recharge_fee) -
                Number(detailData.order_fee) -
                Number(normal_order ? normal_order.normal_fee : 0) +
                Number(creditshop_data.receipts_money || 0)
              ).toFixed(2)
            }}
          </div>
        </div>
        <!-- <div class="print_table_line" style="padding-left:15px">
          银行卡入账：{{settelment.settle_amount}}元 &nbsp;&nbsp; 结算时间：{{settelment.settle_time_s}} ~ {{settelment.settle_time_e}}
        </div>
        <div class="print_table_line" style="padding-left:15px">
          未到账：{{settelment.wait_amount}}元 &nbsp;&nbsp; 时间：{{settelment.wait_time_s}} ~ {{settelment.wait_time_e}}
        </div> -->
        <div class="print_table_line">
          <span>备注：</span>
        </div>
        <div class="print_block_line"></div>
        <div class="print_bottom_line">交班人签字</div>
      </div>
      <div v-if="isCheck" style="text-align: center;">
        <el-button style="margin: 20px auto;" v-print="'#print_table'">
          打印
        </el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="show_selectVersion"
      title="选择交班版本"
      width="1000px"
      :close-on-click-modal="false"
    >
      <Version @saveVersion="saveVersion"></Version>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { changeDutySubmit, classSetList } from "@/api/vip";
import Stat from "@/components/vip/changeDutyStat";
import Version from "@/components/vip/changeDutyVersion";
import { duty_config, privacy } from "../../../../api/set";
import { loading_options } from "@/utils/loading";
import { Loading } from "element-ui";

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  props: {
    detailMsg: {
      // 查看历史记录的数据
      type: Object,
      default: () => {},
    },
    isCheck: {
      // 是否是查看历史记录
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      duty_charge_count: 1,
      room_name: "",
      Duty_type: {},
      detailData: {
        recharge_ids: "",
      }, //详细信息
      settle: {},
      formData: {
        hand_money: "",
        down_money: "",
      }, //表单信息
      ifPrint: false, //是否打印
      class_id: 0, //班次id
      class_key: 0, //班次index
      classList: [], //班次列表
      couldSubmit: false, //可以提交
      showBackButton: false, //打印后显示返回按钮
      timeValue: [], //时间
      empList: [], // 员工交班信息列表
      nowDate: "", //当前班次时间
      show_print: true, //显示打印内容区域
      show_stat: true, //显示收入统计
      show_selectVersion: false, // 选择交班版本弹窗
      settelment: { count: {} }, // 银行卡到账
      normal_order: {},
      creditshop_data: {},
    };
  },
  mounted() {
    this.timeValue = this.$route.query.time || [];
    // console.log(this.formData.room_id)
    console.log(this.isCheck);
    if (!this.isCheck) {
      this.init();
    }
    if (localStorage.getItem("app_id") == "403") {
      this.show_stat = false;
    }
    privacy({ app_id: this.app_id }).then((res) => {
      console.log(res);
      if (res.code == 200) {
        this.duty_charge_count = res.data.duty_charge_count;
      }
    });
  },
  methods: {
    init() {
      // showLoading();
      const loadingInstance = Loading.service(loading_options);
      this.$nextTick(() => {
        classSetList({ token: this.token, app_id: this.app_id }).then((res) => {
          if (res.code == 200) {
            this.class_id = res.data[0].id;
            this.classList = res.data[0].rule;
            this.classList.forEach((item) => {
              if (item.type == 1) {
                item.show_name =
                  item.name + "  " + item.start_time + "~次日" + item.end_time;
              } else {
                item.show_name =
                  item.name + "  " + item.start_time + "~" + item.end_time;
              }
            });
          }
        });
      });
      var data = {
        token: this.token,
        app_id: this.app_id,
        duty_type: 1,
        room_id: this.$route.query.roomid,
      };
      if (this.timeValue.length == 2) {
        console.log("自定义交班时间", this.timeValue);
        data.start_time = this.timeValue[0];
        data.end_time = this.timeValue[1];
      }
      changeDutySubmit(data).then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.detailData = Object.assign(res.data);
          this.normal_order = res.data.normal;
          this.room_name = res.data.room_name;
          this.settle = res.data.settelment.settle;
          this.detailData.gasoli_discount =
            this.detailData.gasoli_order_money == "0"
              ? "0"
              : (
                  Number(this.detailData.gasoli_order_money) -
                  Number(this.detailData.gasoli_amount)
                ).toFixed(2);
          this.detailData.diesel_discount =
            this.detailData.diesel_order_money == "0"
              ? "0"
              : (
                  Number(this.detailData.diesel_order_money) -
                  Number(this.detailData.diesel_amount)
                ).toFixed(2);
          if (this.detailData.begintime == 1) {
            this.nowDate =
              "首次收款" +
              " ~ " +
              this.mydateFormat(Number(this.detailData.endtime));
          } else {
            this.nowDate =
              this.mydateFormat(Number(this.detailData.begintime)) +
              " ~ " +
              this.mydateFormat(Number(this.detailData.endtime));
          }
          this.formData.amount = (
            Number(res.data.cash) + Number(res.data.ex_cash_amount)
          ).toFixed(2);
          this.formData.pretty_cash = res.data.pretty_cash;
          this.detailData.show_recharge_unionpay_amount = (
            Number(res.data.ex_unionpay_amount) +
            Number(res.data.ex_wechat_pay_amount) +
            Number(res.data.ex_ali_pay_amount)
          ).toFixed(2);
          this.detailData.show_order_unionpay_amount = // Number(res.data.wechat_pay) -
            // Number(res.data.ex_wechat_pay_amount) +
            // Number(res.data.consume_unionpay_amount)

            (
              Number(res.data.wechat_pay) +
              Number(res.data.ali_pay) -
              Number(res.data.ex_ali_pay_amount) -
              Number(res.data.ex_wechat_pay_amount) -
              Number(res.data.normal ? res.data.normal.normal_wxpay : 0) +
              Number(res.data.consume_unionpay_amount)
            ).toFixed(2);
          this.detailData.show_unionpay_total = (
            Number(res.data.unionpay_amount) +
            Number(res.data.wechat_pay) +
            Number(res.data.ali_pay)
          ).toFixed(2);
          this.detailData.show_all_recharge = (
            Number(res.data.oil_card_money) +
            Number(res.data.family_card_money) +
            Number(res.data.car_card_money) +
            Number(res.data.balance)
          ).toFixed(2);
          this.settelment = res.data.settelment || { settle: {} };
          this.creditshop_data = res.data.creditshop_order_data || {};
          // hideLoading()
          this.$nextTick(() => {
            loadingInstance.close();
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
          // hideLoading()
          this.$nextTick(() => {
            loadingInstance.close();
          });
        }
      });
      duty_config({ app_id: this.app_id }).then((res) => {
        this.Duty_type = res.data;
        if (res.data.duty_type == 0) {
          this.checkVersion();
        }
        if (res.data.duty_type == 2) {
          localStorage.setItem("changeDutyVersion", 2);
          var thisQuery = this.$route.query;
          this.$router.replace({ path: "changeDutyNew2", query: thisQuery });
        }
      });
    },
    submit() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        hand_money: this.formData.hand_money,
        down_money: this.formData.down_money,
        class_id: this.class_id,
        class_key: this.class_key,
        duty_type: 1,
        room_id: this.$route.query.roomid,
      };
      if (this.timeValue.length == 2) {
        console.log("自定义交班时间", this.timeValue);
        data.start_time = this.timeValue[0];
        data.end_time = this.timeValue[1];
      }
      // return false;
      changeDutySubmit(data).then((res) => {
        if (res.code == 200) {
          this.couldSubmit = false;
          if (this.ifPrint) {
            this.showBackButton = true;
          } else {
            this.$message({
              type: "success",
              message: "交班成功",
            });
            this.gotoHome();
            // this.$router.go(-2);
          }
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    changeMoney(i) {
      var all =
        Number(this.formData.amount) + Number(this.formData.pretty_cash);
      if (i == 1) {
        //编辑上交金额
        if (Number(this.formData.hand_money) > all) {
          this.$message({
            type: "error",
            message: "上交金额不能大于总金额",
          });
          this.couldSubmit = false;
        } else {
          if (this.formData.hand_money) {
            this.formData.down_money = all - Number(this.formData.hand_money);
            this.formData.down_money = this.formData.down_money.toFixed(2);
            this.couldSubmit = true;
          }
        }
      } else {
        //编辑下发金额
        if (Number(this.formData.down_money) > all) {
          this.$message({
            type: "error",
            message: "下发金额不能大于总金额",
          });
          this.couldSubmit = false;
        } else {
          if (this.formData.down_money) {
            this.formData.hand_money = all - Number(this.formData.down_money);
            this.formData.hand_money = this.formData.hand_money.toFixed(2);
            this.couldSubmit = true;
          }
        }
      }
      if (this.formData.hand_money && this.formData.down_money) {
        this.couldSubmit = true;
      } else {
        this.couldSubmit = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    gotoHome() {
      this.$router.go(-2);
    },
    printTable() {
      console.log(this.$refs.printBtn);
    },
    checkVersion() {
      // 进页面判断是新版交班还是旧版交班
      var version = localStorage.getItem("changeDutyVersion");
      console.log("version: -----------", version);
      if (version == 2) {
        this.gotoNew2();
      } else if (!version) {
        this.show_selectVersion = true;
      }
    },
    saveVersion(i, s) {
      // 记住选择的交班版本
      this.show_selectVersion = false;
      if (s) {
        localStorage.setItem("changeDutyVersion", i);
      }
      if (i == 2) {
        this.gotoNew2();
      }
    },
    gotoNew2() {
      localStorage.setItem("changeDutyVersion", 2);
      var thisQuery = this.$route.query;
      this.$router.replace({ path: "changeDutyNew2", query: thisQuery });
    },
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Stat,
    Version,
  },
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .title_line {
    height: 34px;
  }
  .content {
    background: #fff;
    padding: 24px 20px 0 24px;
    .options {
      height: 50px;
      line-height: 50px;
      display: flex;
      .time_options {
        flex: 1;
      }
      .button_options {
        margin-right: 10px;
      }
      .date_picker_box {
        width: 130px;
      }
      .time_picker_box {
        width: 95px;
        margin-right: 8px;
      }
    }
    .top_stat {
      line-height: 30px;
      font-size: 14px;
      .stat_line {
        display: flex;
        line-height: 40px;
        flex-wrap: wrap;
        padding: 10px 80px 0 20px;
        .stat_item {
          margin-right: 50px;
        }
      }
    }
    .emp_table {
      padding: 20px;
    }
    .bottom_stat {
      line-height: 40px;
      font-size: 14px;
      display: flex;
      padding: 0 20px;
      .oils_type {
        flex: 1;
        display: flex;
        div {
          margin-right: 40px;
        }
      }
      .stat_item {
        margin-right: 30px;
      }
    }
    .form_title {
      width: 90%;
      border: 1px solid #91d5ff;
      background: #e6f7ff;
      height: 40px;
      line-height: 40px;
      padding-left: 17px;
      color: #21aaff;
      border-radius: 4px;
    }
    .form_box {
      margin-top: 10px;
      padding: 10px;
      .form_input_box {
        width: 300px;
      }
    }
  }
  .button_box {
    background: #fff;
    padding-left: 154px;
  }
}
.print_table {
  width: 840px;
  border: 1px solid #333;
  font-size: 14px;
  color: #333;
  .print_table_line {
    line-height: 46px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    border-top: 1px solid #333;
    div {
      text-align: center;
      // padding: 0 10px;
      // border-left: 1px solid #333;
    }
    div:first-child {
      border-left: none;
    }
    span {
      padding-left: 10px;
    }
    .info_text {
      font-size: 12px;
      flex: 1;
      color: #ff1131;
    }
  }
  .print_table_line1 {
    line-height: 46px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    border-top: 1px solid #333;
    div {
      text-align: center;
      padding: 0 10px;
      border-left: 1px solid #333;
    }
    div:first-child {
      border-left: none;
    }
    span {
      padding-left: 10px;
    }
    .info_text {
      font-size: 12px;
      flex: 1;
      color: #ff1131;
    }
  }
  .noborder {
    border: none !important;
  }
  .flex1 {
    flex: 1;
  }
  .half_lh {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0px 10px 20px;
    .half_item {
      // line-height: 28px;
      width: 225px;
      text-align: left;
      border: none;
    }
  }
  .flex2 {
    flex: 2;
  }
  // .flex10 {
  // 	flex: 50;
  // }
  // .flex11 {
  // 	flex: 40;
  // }
  // .flex12 {
  // 	flex: 100;
  // }
  .flex3 {
    flex: 3;
  }
  .flex4 {
    flex: 4;
  }
  .flex5 {
    flex: 6;
    div {
      border: none;
      padding: 0;
    }
    .detail_line {
      padding: 0;
      font-size: 17px;
      display: flex;
    }
    .small_line {
      line-height: 40px;
      padding: 0;
      margin: 0 5px;
    }
  }
  .flex1_ex {
    width: 138.83px;
  }
  .flex1_ex_li {
    display: flex;
    flex: 1;
    div {
      flex: 1;
    }
  }
  .print_block_line {
    height: 60px;
  }
  .print_bottom_line {
    padding-right: 160px;
    text-align: right;
    margin-bottom: 30px;
  }
}
.print_table_line {
  line-height: 50px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  // border: 1px solid #333;
  border-bottom: none;
  text-align: center;
  div {
    padding: 0;
    border-left: 1px solid #333;
  }
  span {
    padding-left: 10px;
  }
  .bd_none {
    border: none !important;
  }
  .info_text {
    font-size: 12px;
    flex: 1;
    color: #ff1131;
  }
  .column1 {
    width: 78px;
    border-left: none;
  }
  .flex1 {
    flex: 1;
  }
  .half_lh {
    display: flex;
    flex-wrap: wrap;
    padding: 6px 0px 6px 10px;
  }
  .head_line {
    width: 120px;
    border-left: 1px solid #333;
  }
  .color_g {
    color: #00cd66;
    margin-left: 0;
  }
  .flex_span {
    margin: 0 10px;
    font-size: 13px;
  }
  .flex_right {
    margin-right: 15px;
    text-align: right;
  }
  .part_recharge {
    width: 150px;
    padding: 0;
  }
  .part_order {
    width: 240px;
    padding: 0;
  }
  .part_stat {
    flex: 1;
    padding: 0;
  }
  .part_title {
    line-height: 34px;
    height: 34px;
    border-bottom: 1px solid #333;
    border-left: none;
  }
  .part_line {
    line-height: 46px;
    display: flex;
    border-left: none;
    .part_item {
      font-size: 12px;
      flex: 1;
    }
    .part_item_payment {
      width: 72px;
      font-size: 12px;
    }
    .bd_left {
      border-left: 1px solid #333;
    }
  }
  .line_h50 {
    line-height: 50px !important;
  }
}
.print_table_line2 {
  line-height: 50px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  // border: 1px solid #333;
  border-bottom: none;
  text-align: center;
  div {
    padding: 0;
    border-left: 1px solid #333;
  }
  span {
    padding-left: 10px;
  }
  .bd_none {
    border: none !important;
  }
  .info_text {
    font-size: 12px;
    flex: 1;
    color: #ff1131;
  }
  .column1 {
    width: 78px;
    border-left: none;
  }
  .flex1 {
    flex: 1;
  }
  .half_lh {
    display: flex;
    flex-wrap: wrap;
    padding: 6px 0px 6px 10px;
  }
  .head_line {
    width: 120px;
    border-left: 1px solid #333;
  }
  .color_g {
    color: #00cd66;
    margin-left: 0;
  }
  .flex_span {
    margin: 0 10px;
    font-size: 13px;
  }
  .flex_right {
    margin-right: 15px;
    text-align: right;
  }
  .part_recharge {
    width: 150px;
    padding: 0;
  }
  .part_order {
    width: 240px;
    padding: 0;
  }
  .part_stat {
    flex: 1;
    padding: 0;
  }
  .part_title {
    line-height: 34px;
    height: 34px;
    border-bottom: 1px solid #333;
    border-left: none;
  }
  .part_line {
    line-height: 46px;
    display: flex;
    border-left: none;
    .part_item {
      font-size: 12px;
      flex: 1;
    }
    .part_item_payment {
      width: 72px;
      font-size: 12px;
    }
    .bd_left {
      border-left: 1px solid #333;
    }
  }
  .line_h50 {
    line-height: 50px !important;
  }
}
</style>
